import { isStateOfPip } from "./script"
import { medPayMPPolicyStatusOptionsPayerTypes, medPayPIPPolicyStatusOptionsPayerTypes } from "./systemData"

export const medpayFunctions = {
    isDriverAlreadySelected: (activeCase, currentItem) => {
        if (activeCase && activeCase.mp_pip_um && activeCase.mp_pip_um.length > 0) {
            let driver = activeCase.mp_pip_um.some(item => item.ins_owner == 1 && item.id != currentItem.id)
            return driver ? true : false
        }
        return false
    },
    isInsuranceOwner: (activeCase, currentItem) => {
        if (currentItem && currentItem.ins_case_owner_id && currentItem.ins_case_owner_id == activeCase?.case?.id) {
            return true
        } 
        return false
    },
    medpayVerification: (medpayArr, activeCase) => {
        // Improved for readability

        // Initialize tab state and find primary insurance
        let tabState = {
            dot: false,
            dot_color: null,
            background: null,
            color: null,
            message: null
        };

        let primaryInsurance = null;

        // on patient details page, medpayArr is an array and on work queue page, medpayArr is an object
        if (Array.isArray(medpayArr) && medpayArr.length > 0) {
            primaryInsurance = medpayArr.find(item => item.is_primary_insurance);
        } else if (Array.isArray(medpayArr)) {
            primaryInsurance = null;
        } else {
            primaryInsurance = medpayArr;
        }

        if (primaryInsurance) {
            const arr = [];  
            const isPipState = isStateOfPip(primaryInsurance?.insurance_state);
            const isInsuranceNotValid = isPipState ? (primaryInsurance.has_pip == 0 && primaryInsurance.has_mp == 0) ||
            (primaryInsurance.pip_exausted && primaryInsurance.mp_exausted) ||
            (primaryInsurance.has_pip != 1 && (primaryInsurance.has_mp == 0 || primaryInsurance.mp_exausted)) 
            : 
            (primaryInsurance.has_mp == 0 || primaryInsurance.mp_exausted)


            // ---- Green (Good) ----

            // if (
            //     (primaryInsurance.mp_verified && primaryInsurance.has_mp) ||
            //     (isPipState && primaryInsurance.has_pip)
            // ) {
            //     tabState.background = 'var(--green-verification)';
            //     tabState.color = `var(--text)`;
            // }

            // ---- Yellow (Warning) ----

            // // MP policy not verified but exists
            // if (!isInsuranceNotValid && primaryInsurance.has_mp && !primaryInsurance.mp_verified) {
            //     arr.push('MP - Policy is not verified');
            //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //     tabState.color = `var(--dark-yellow)`;
            // }

            // // PIP policy not verified but exists (and it's a PIP state)
            // if (!isInsuranceNotValid && isPipState && primaryInsurance.has_pip && !primaryInsurance.pip_verified) {
            //     arr.push('PIP - Policy is not verified');
            //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //     tabState.color = `var(--dark-yellow)`;
            // }

            // // PIP status not open or billing or ready to bill (not exhausted) -- not billing ==3  or open ==2 or ready to bill ==9
            // if (
            //     !isInsuranceNotValid &&
            //     isPipState &&
            //     primaryInsurance.has_pip &&
            //     !primaryInsurance.pip_exausted &&
            //     ![2, 3, 9].includes(primaryInsurance.pip_status)
            // ) {
            //     arr.push('PIP Status is NOT Open or Billing or Ready to Bill');
            //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //     tabState.color = `var(--dark-yellow)`;
            // }

            // // No PIP or it's exhausted; MP status not open/billing/ready to bill (not exhausted) -- not billing ==3  or open ==2 or ready to bill ==9
            // if (
            //     !isInsuranceNotValid &&
            //     !isPipState &&
            //     ((primaryInsurance.has_pip && primaryInsurance.pip_exausted) || !primaryInsurance.has_pip) &&
            //     primaryInsurance.has_mp &&
            //     !primaryInsurance.mp_exausted &&
            //     ![2, 3, 9].includes(primaryInsurance.mp_status)
            // ) {
            //     arr.push('MP Status is NOT Open or Billing or Ready to Bill');
            //     tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
            //     tabState.color = `var(--dark-yellow)`;
            // }

            // ---- Red (Error/Critical) ----

            if (isInsuranceNotValid) {
                arr.push(isPipState ? 'No MP/PIP or Exhausted' : 'No MP or Exhausted');
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
                tabState.color = `var(--red)`;
                tabState.classColor = null;
            }

            // ---- Dot indicators (Critical missing data) ----

            // Driver Excluded
            if (!isInsuranceNotValid && primaryInsurance.driver_excluded) {
                arr.push('Driver Excluded');
                tabState.dot = true;
                tabState.dot_color = `var(--red)`;
            }

            // Policy number was not provided
            if (!isInsuranceNotValid && !primaryInsurance.mp_claim_number && !primaryInsurance.policy_number) {
                arr.push('Policy Number was not provided');
                tabState.dot = true;
                tabState.dot_color = `var(--red)`;
            }

            if (!isInsuranceNotValid && primaryInsurance.mp_verified) {
                // MP claim number not provided
                if (!primaryInsurance.mp_claim_number) {
                    arr.push('Claim Number was not provided');
                    tabState.dot = true;
                    tabState.dot_color = `var(--red)`;
                }

                // PIP amount missing (applies only for PIP state, PIP present and not exhausted)
                if (
                    isPipState &&
                    primaryInsurance.has_pip == 1 &&
                    !primaryInsurance.pip_exausted &&
                    !(primaryInsurance.pip_policy_limit )
                ) {
                    arr.push('PIP Limit was not provided');
                    tabState.dot = true;
                    tabState.dot_color = `var(--red)`;
                }

                // MP amount missing (MP present, not exhausted, but amount missing)
                if (
                    primaryInsurance.has_mp == 1 &&
                    !primaryInsurance.mp_exausted &&
                    !(primaryInsurance.mp_policy_limit )
                ) {
                    arr.push('MP Limit was not provided');
                    tabState.dot = true;
                    tabState.dot_color = `var(--red)`;
                }
            }

            // START status color logic
            if (!isInsuranceNotValid) {
                if (isPipState &&
                    primaryInsurance.has_pip &&
                    !primaryInsurance.pip_exausted) {

                        let pip_option = medPayPIPPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryInsurance.pip_status)
                        if (pip_option) {
                            tabState.classColor = 'bk_' + pip_option.color?.split(' ').join('_')
                        }
                } else {
                        let mp_option = medPayMPPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryInsurance.mp_status)
                        if (mp_option) {
                            tabState.classColor = 'bk_' + mp_option.color?.split(' ').join('_')
                        }
                }
            }
            // END status color logic

            // ---- Message Construction ----

            if (arr.length > 0) {
                tabState.message =
                    '<div>' +
                    arr.map(item => `<div>${item}</div>`).join('') +
                    '</div>';
            }
        }

        return tabState;
    }
}
